import Icon from 'vue-awesome/components/Icon'

Icon.register({
  airline_seat_flat_angled_sharp: {
    paths: [
      {
        d: 'M21.56 16.18L9.2 11.71l2.08-5.66 12.35 4.47-2.07 5.66zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94a3.01 3.01 0 001.41-4A3.005 3.005 0 004.7 4.8a2.99 2.99 0 00-1.4 4 2.99 2.99 0 004 1.4z'
      }
    ],
    width: '24',
    height: '24'
  }
})
